/**
 * create-mode-sheet.js — [Создать фото / Создать видео] на view-home.
 *
 * Поведение:
 *   Обе кнопки видны сразу (CSS-дефолт .create-cta-options, см.
 *   create-cta.css) — без промежуточного тапа на большую «Создать».
 *   Юзер 2026-08-22: «кнопки нужно сразу показать без отдельной
 *   большой» (раньше был tap-to-reveal morph). Tap любой → switchView
 *   в соответствующий редактор.
 *
 *   Фолбэк (video-флаг OFF, .is-single на shell'е) — сплитить нечего,
 *   одна кнопка «Создать» ведёт прямо в view-custom-style.
 *
 * Файл сохраняет имя — он в lazy-loader manifest'е.
 */
(function () {
    'use strict';

    // Фича-флаг видео-пайплайна.
    // ⚠️ ИСТОЧНИК ИСТИНЫ: window.APP_VIDEO_ENABLED, инжектится бэком
    // в <head> index.html (см. webapp_server.handle_index). Хостнейм-
    // регексп раньше иногда возвращал false в iOS Telegram WebView →
    // морф не работал, юзер моментально проваливался в view-custom-style.
    // Url-параметр ?video=1 оставлен для ручного теста с прода.
    function videoEnabled() {
        try {
            if (new URLSearchParams(location.search).get('video') === '1') return true;
            if (window.APP_VIDEO_ENABLED === true) return true;
            // Fallback на hostname только если бэк не инжектил флаг
            // (старая версия webapp_server без handle_index-инжекта).
            if (window.APP_VIDEO_ENABLED === undefined) {
                return /(^|\.)dev\.lora\.pro$/i.test(location.hostname);
            }
            return false;
        } catch (e) {
            return false;
        }
    }

    const SHELL_ID = 'createCta';
    const BTN_ID = 'customPromptBtn';
    const OPTIONS_ID = 'createCtaOptions';

    function shell() { return document.getElementById(SHELL_ID); }

    // CSS-дефолт уже сплит (никакого flash большой кнопки на первом
    // paint) — .is-single ставим ТОЛЬКО как фолбэк, когда сплитить
    // нечего. Идемпотентно, безопасно звать повторно из attach().
    function applyMode() {
        const s = shell();
        if (!s) return;
        s.classList.toggle('is-single', !videoEnabled());
    }

    function handleOptionClick(e) {
        const opt = e.target.closest('[data-create-mode]');
        if (!opt) return;
        e.preventDefault();
        e.stopPropagation();
        const tg = window.APP?.tg;
        if (tg?.HapticFeedback) tg.HapticFeedback.impactOccurred('medium');
        const mode = opt.dataset.createMode;
        if (mode === 'photo') window.switchView?.('view-custom-style');
        else if (mode === 'video') window.switchView?.('view-create-video');
    }

    function onCreateClick(e) {
        // .is-single фолбэк — единственная кнопка «Создать» ведёт
        // прямо в view-custom-style (как раньше делал references.js).
        const tg = window.APP?.tg;
        if (tg?.HapticFeedback) tg.HapticFeedback.impactOccurred('medium');
        e?.preventDefault?.();
        window.switchView?.('view-custom-style');
    }

    function attach() {
        applyMode();

        const btn = document.getElementById(BTN_ID);
        if (btn && !btn.dataset.modeMorphAttached) {
            btn.dataset.modeMorphAttached = '1';
            btn.addEventListener('click', onCreateClick);
        }

        const opts = document.getElementById(OPTIONS_ID);
        if (opts && !opts.dataset.modeMorphAttached) {
            opts.dataset.modeMorphAttached = '1';
            opts.addEventListener('click', handleOptionClick);
        }
    }

    if (document.readyState !== 'loading') attach();
    else document.addEventListener('DOMContentLoaded', attach);
    // references.js перевешивает onclick после первого fetch'а каталога —
    // двойной re-attach страхует.
    setTimeout(attach, 1500);
    setTimeout(attach, 4000);
})();
